import React from "react";
import { makeStyles } from "@mui/styles";
import { TextField, Autocomplete } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const useStyles = makeStyles((theme) => ({
	TextFieldStyle: {
		width: "100%",
		background: "#FCFCFD",
		paddingRight: "0rem",
		borderRadius: "0.8rem",
		fontSize: "1.6rem",
		fontFamily: "Inter-Medium",
		lineHeight: "2.4rem",
		border: "none",
		"& input": {
			fontSize: "1.6rem",
			lineHeight: "2.4rem",
			color: "#667085 !important",
			// padding: '1.3rem 1.4rem',
			padding: "0rem !important",
			background: "#FCFCFD",
			minHeight: "3rem",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "none",
			borderRadius: "10px !important",
		},
		"& .MuiInputBase-root": {
			background: "#FCFCFD",
			borderRadius: "0.8rem",
			border: "1px solid  #D0D5DD",
			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
		},
		"&.Mui-focused": {
			background: "#FFFFFF !important",
			border: "1px solid #EFF8FF",
			boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
		},
		"&.Mui-error": {
			border: "1px solid red",
			boxShadow: "none",
		},
		"& .MuiSvgIcon-root": {
			transform: "scale(1.8)",
			margin: "0.4rem",
		},
		"& 	.MuiAutocomplete-tag": {
			fontSize: "1.4rem !important",
		},
	},
	inputStyle: {
		fontFamily: "Inter-Medium",
		paddingRight: "0rem",
		fontSize: "1.6rem ",
		lineHeight: "2.4rem ",
		boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
		borderRadius: "10px !important",
	},
	textStyle: {
		fontSize: "1.6rem ",
		fontFamily: "Inter-Regular",
		lineHeight: "2.4rem ",
		borderBottom: "1px solid #EFF8FF",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		// padding:'0.5rem 1rem',
	},
	helperText: {
		background: "#FFFFFF !important",
		fontSize: "1.4rem !important",
		margin: "0.5rem 0 0 0 !important",
		fontFamily: "Inter-Medium !important",
		lineHeight: "1.8rem !important",
		paddingTop: "0.5rem !important ",
		color: "#d32f2f ",
	},
}));

function CustomAutoComplete({
	list = [],
	disable = true,
	freeSolo = false,
	placeholder = "",
	getOptionLabel,
	InputValue,
	multiple = false,
	SecondInputValue,
	NoOptionsText,
	value,
	InitialValue,
	renderOption,
	OnInputChange,
	helperText = "",
	filterOptions,
}) {
	const classes = useStyles();
	return (
		<>
			<Autocomplete
				multiple={multiple}
				freeSolo={freeSolo}
				id="combo-box-demo"
				value={value}
				onChange={(e, newValue) => {
					InitialValue(newValue);
				}}
				inputValue={SecondInputValue}
				onInputChange={OnInputChange}
				options={placeholder !== "Enter Group Name" ? list : list.map((m) => m.groupName)}
				isOptionEqualToValue={(option, value) => option.value === value.value}
				filterOptions={filterOptions}
				classes={{
					option: classes.textStyle,
				}}
				sx={{
					"& .MuiInputBase-root": {
						border: helperText === "" ? " 1px solid  #D0D5DD !important" : " 1px solid #D0D5DD !important",
						minHeight: "2rem",
					},
				}}
				ChipProps={{
					sx: {
						" .MuiChip-deleteIcon": {
							fontSize: "1.2rem !important",
							margin: "0 1.2rem 0 0",
						},
					},
				}}
				disabled={disable}
				renderOption={renderOption}
				noOptionsText={NoOptionsText}
				clearOnBlur={true}
				getOptionLabel={getOptionLabel}
				popupIcon={<KeyboardArrowDownIcon />}
				className={classes.TextFieldStyle}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder={placeholder}
						sx={{
							" .MuiFormHelperText-root ": {
								background: "#FFFFFF !important",
								fontSize: "1.2rem !important",
								margin: "0rem 0 0 0 !important",
								fontFamily: "Inter-Medium !important",
								lineHeight: "1.6rem !important",
								paddingTop: "0.5rem !important ",
							},
						}}
					/>
				)}
			/>
			<p className={classes.helperText}>{helperText}</p>
		</>
	);
}

export default CustomAutoComplete;
